export default __webpack_public_path__ + "static/media/i-process.21f474ac.svg";